import React, { Component } from 'react';
import FormErrors from "../FormErrors";
import { validateForm } from "../utility";
import { Auth } from '../../Auth';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const InputText = ({ id, value, label, type = 'text', onChange }) => {
  return <div className="form-group">
    <label htmlFor="username">{label}</label>
    <input
      className="form-control"
      type={type}
      id={id}
      value={value}
      onChange={onChange}
    />
  </div>
}

class LogIn extends Component {
  state = {
    username: "",
    password: "",
    errors: {
      cognito: null,
      blankfield: false
    }
  };

  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false
      }
    });
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.clearErrorState();
    const error = validateForm(event, this.state);
    if (error) {
      this.setState({
        errors: { ...this.state.errors, ...error }
      });
    }
    const { username, password } = this.state
    try {
      const auth = new Auth()
      const user = await auth.signIn({ username: username.trim(), password });
      this.props.dispatch({
        type: 'setUsuario',
        payload: { ...user },
      });
      this.props.history.push("/");
    } catch (error) {
      let err = null
      err = !error.message ? { "message": error } : error;
      this.setState({
        errors: {
          ...this.state.errors,
          cognito: err
        }
      })
    }
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    document.getElementById(event.target.id).classList.remove("is-danger");
  };

  render() {
    return (
      <section className="section auth">
        <div className="container">
          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <h1>Inicio de sesión</h1>
              <FormErrors formerrors={this.state.errors} />
              <form className='form' onSubmit={this.handleSubmit}>
                <InputText
                  id='username'
                  value={this.state.username}
                  label='Correo electronico'
                  onChange={this.onInputChange}
                />
                <InputText
                  id='password'
                  value={this.state.password}
                  label='Contraseña'
                  onChange={this.onInputChange}
                  type='password'
                />
                <div className="field">
                  <p className="control">
                    <button className="btn btn-primary">
                      ENTRAR
                    </button>
                  </p>
                </div>
                <div className="field">
                  <p className="control">
                    <a className="btn btn-primary" href='/register'>
                      REGISTRO
                    </a>
                  </p>
                </div>
                <div className="field">
                  <p className="control">
                    <a href="/forgotpassword">Olvide mi clave?</a>
                  </p>
                </div>
              </form>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStoreToProps = (state, ownProps) => {
  return { ...ownProps, usuario: state.usuario || {} }
}
export default withRouter(connect(mapStoreToProps)(LogIn));